export const ROUTES_RESET_STATE = 'ROUTES_RESET_STATE';
export const ROUTES_CURRENT_ITEM = 'ROUTES_CURRENT_ITEM';

export const ROUTES_REQUEST_LOADING = 'ROUTES_REQUEST_LOADING';
export const ROUTES_REQUEST_SUCCESS = 'ROUTES_REQUEST_SUCCESS';
export const ROUTES_REQUEST_FAILED = 'ROUTES_REQUEST_FAILED';

export const ROUTES_CURRENT_ACTION = 'ROUTES_CURRENT_ACTION';
export const ROUTES_RESET_ACTION = 'ROUTES_RESET_ACTION';